import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import Layout from '../../../components/layout/Layout';
import { BarChart3, DollarSign, Star } from 'lucide-react'; 
import BusinessSnapshotPanel from '../../../features/dashboard/standard/BusinessSnapshotPanel';
// ✅ IMPORTAR EL NUEVO COMPONENTE DE RENDIMIENTO
import RewardsPerformancePanel from '../../../features/dashboard/analytics/RewardsPerformancePanel';
// Panel superior: salud del programa + insight accionable (adaptado al modelo de negocio)
import ProgramHealthPanel from '../components/ProgramHealthPanel';
// Fase 2: tendencia de visitas (revivido) + heatmap de horas pico
import VisitsTrendsPanel from '../../../components/dashboard/VisitsTrendsPanel';
import VisitsHeatmapPanel from '../components/VisitsHeatmapPanel';
// Fase 3: segmentos RFM + lista de clientes a reactivar
import RfmSegmentsPanel from '../components/RfmSegmentsPanel';
// Fase 4: satisfacción / NPS (panel ya existente, ahora con su endpoint vivo)
import FeedbackAnalyticsPanel from '../../../components/dashboard/FeedbackAnalyticsPanel';

const BusinessAnalyticsPage: React.FC = () => {
  const { currentUser } = useAuth();
  
  // 1. Detección de Modo para la UI
  const loyaltyMode = currentUser?.loyaltyMode || 'visits';

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header / Title */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          <h1 className="text-2xl font-bold text-content flex items-center">
            <BarChart3 className="h-6 w-6 mr-2 text-accent" />
            Análisis de tu Negocio
          </h1>
          
          {/* Indicador Visual de Modo */}
          <div className="mt-1 flex items-center text-sm text-content-2">
            <span>Visualiza métricas y tendencias de {currentUser?.businessName || 'tu negocio'}</span>
            <span className="mx-2">•</span>
            <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${loyaltyMode === 'cashback' ? 'bg-green-100 dark:bg-green-500/20 text-green-800 dark:text-green-300' : 'bg-yellow-100 dark:bg-yellow-500/20 text-yellow-800 dark:text-yellow-300'}`}>
                {loyaltyMode === 'cashback' ? (
                    <>
                        <DollarSign className="w-3 h-3 mr-1" /> Modo Cashback
                    </>
                ) : (
                    <>
                        <Star className="w-3 h-3 mr-1" /> Modo Puntos
                    </>
                )}
            </span>
          </div>
        </div>

        {/* PANEL 0: Salud del programa + Insight accionable (adaptado al modelo) */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          <ProgramHealthPanel />
        </div>

        {/* PANEL 1: Resumen General (Métricas de Visitas y Clientes) */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          <BusinessSnapshotPanel />
        </div>

        {/* PANEL 1.5: Tendencia de visitas (Fase 2) */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          <VisitsTrendsPanel />
        </div>

        {/* PANEL 1.6: Horas pico — ancho completo para que el heatmap respire (Fase 2) */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          <VisitsHeatmapPanel />
        </div>

        {/* ✅ PANEL 2: Rendimiento de Recompensas (NUEVO) */}
        {/* Esto mostrará cuánto estás gastando y qué premios son los favoritos */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
           <RewardsPerformancePanel />
        </div>

        {/* PANEL 3: Segmentos RFM + clientes a reactivar (Fase 3) */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
           <RfmSegmentsPanel />
        </div>

        {/* PANEL 4: Satisfacción / NPS (Fase 4) */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
           <FeedbackAnalyticsPanel />
        </div>

      </div>
    </Layout>
  );
};

export default BusinessAnalyticsPage;